import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[600px] lg:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20comic%20art%20collage%20with%20dynamic%20panel%20shapes%2C%20stylized%20brush%20strokes%20and%20halftone%20dot%20texture%2C%20warm%20amber%20and%20coral%20palette%20over%20a%20deep%20brown%20cream%20base%2C%20layered%20paper%20cut%20feel%2C%20no%20text%2C%20no%20faces%2C%20editorial%20poster%20illustration%2C%20high%20detail%2C%20harmonious%20composition&width=1920&height=1080&seq=hero-manga-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24">
        <div className="max-w-5xl mx-auto text-center animate-fadeUp">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm backdrop-blur-sm border border-background-50/20">
            <i className="ri-book-shelf-line"></i>
            韩漫 · 日漫 · 国漫 三体系分类
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            全彩漫画分类指南
            <span className="block mt-2 text-primary-300">帮你快速定位喜欢的作品</span>
          </h1>

          <p className="mt-6 max-w-2xl mx-auto text-sm md:text-base text-background-50/85 leading-relaxed">
            这里按类型汇总韩漫、日漫、国漫等彩色全彩漫画，方便你快速找到想看的作品。无论偏好哪种画风或题材，
            都能通过分类指南直接定位，省去盲目翻找的时间，轻松开始阅读。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#genres"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-compass-3-line"></i>
              浏览分类指南
            </a>
            <a
              href="#recommend"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 text-background-50 font-medium whitespace-nowrap cursor-pointer border border-background-50/30 hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-fire-line"></i>
              查看精选推荐
            </a>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 backdrop-blur-sm">
            {heroStats.map((s) => (
              <div key={s.label} className="px-4 py-5 bg-black/20">
                <p className="font-heading text-xl md:text-2xl font-bold text-primary-300">{s.value}</p>
                <p className="mt-1 text-xs md:text-sm text-background-50/80">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}